import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const JobDetailsHeader = ({ title, subtitle }) => (
  <Box
    w="100%"
    bgGradient="linear(to-b, #25575F, #1B3A4B)"
    py={{ base: 16, md: 28 }} // উচ্চতা বাড়ানো
    px={{ base: 2, md: 8 }}
    textAlign="center"
    borderTopRadius="2xl"
  >
    <Text fontSize={{ base: '2xl', md: '3xl', lg: '4xl' }} fontWeight="extrabold" mb={2} color="#D6FF3F" letterSpacing="wide">
      {title}
    </Text>
    <Text fontSize={{ base: 'md', md: 'xl' }} color="gray.200" opacity={0.95} fontWeight="medium">
      {subtitle}
    </Text>
  </Box>
);

export default JobDetailsHeader; 